import React from 'react';

const HappinessImage = props => {
  return <img {...props} alt=" " />;
};

export default HappinessImage;
